import axios from 'axios'
import SellerInboundCurationService from 'domains/seller-inbound/services/curation'

const API_PATH = 'api/v2/admins/sellers/inbounds/curations'

const SellerInboundCurationApiV2 = {
  /**
   * Accept the product and create an seller product
   * @param {number} inbound_id - Seller Inbound ID
   * @param {object} values - Formik's Values
   * @param {array} attributes - Product Attributes
   */
  accept: async ({ inbound_id, values, attributes }) => {
    const path             = `${API_PATH}/accept`
    const generatedPayload = SellerInboundCurationService.buildPayload(
      values,
      attributes,
      {
        inbound_id     : inbound_id,
        inbound_source : values.inbound_source
      }
    )

    const body = {
      curation: generatedPayload
    }

    const response = axios.post(path, body)
    return response
  },

  /**
   * Reject the product and create an seller product & seller rejected product
   * @param {number} inbound_id - Seller Inbound ID
   * @param {string} product_info - Rejected product info
   * @param {string} reason - Reject reason
   * @param {string} note - Rejected product description
   */
  reject: async ({
    inbound_id,
    product_info,
    reason,
    note
  }) => {
    const path = `${API_PATH}/reject`
    const body = {
      curation: {
        inbound_id       : inbound_id,
        rejected_product : {
          product_info : product_info,
          reason       : reason,
          note         : note
        }
      }
    }

    const response = axios.post(path, body)
    return response
  },

  /**
   * Update the accepted product
   * @param {number} seller_product_id - Seller Product ID
   * @param {number} inbound_id - Seller Inbound ID
   * @param {object} values - Formik's Values
   * @param {array} attributes - Product Attributes
   */
  update_accept: async ({
    seller_product_id,
    inbound_id,
    values,
    attributes
  }) => {
    const path             = `${API_PATH}/update_accept`
    const generatedPayload = SellerInboundCurationService.buildPayload(
      values,
      attributes,
      {
        seller_product_id : seller_product_id,
        inbound_id        : inbound_id,
        inbound_source    : values.inbound_source
      }
    )

    const body = {
      curation: generatedPayload
    }

    const response = axios.patch(path, body)
    return response
  },

  /**
   * Update the rejected product
   * @param {number} seller_product_id - Seller Product ID
   * @param {number} inbound_id - Seller Inbound ID
   * @param {string} product_info - Rejected product info
   * @param {string} reason - Reject reason
   * @param {string} note - Rejected product description
   */
  update_reject: async ({
    seller_product_id,
    inbound_id,
    product_info,
    reason,
    note
  }) => {
    const path = `${API_PATH}/update_reject`
    const body = {
      curation: {
        seller_product_id : seller_product_id,
        inbound_id        : inbound_id,
        rejected_product  : {
          product_info : product_info,
          reason       : reason,
          note         : note
        }
      }
    }

    const response = axios.patch(path, body)
    return response
  },

  /**
   * Delete Seller Product at the curation process
   * @param {number} inbound_id - Seller Inbound ID
   * @param {number} seller_product_id - Seller Product ID
   */
  delete_product: async ({ inbound_id, seller_product_id }) => {
    const path = `${API_PATH}/delete_product`
    const body = {
      curation: {
        inbound_id        : inbound_id,
        seller_product_id : seller_product_id
      }
    }

    const response = axios.patch(path, body)
    return response
  },
  /**
   * Confirm the curation process and send email to Seller
   * @param {number} inbound_id - Seller Inbound ID
   */
  confirm: async (
    inbound_id
  ) => {
    const path = `${API_PATH}/confirm`
    const body = {
      curation: {
        inbound_id: inbound_id
      }
    }

    const response = axios.patch(path, body)
    return response
  }
}

export default SellerInboundCurationApiV2
